import Vue from 'vue';
import VueRouter from 'vue-router';
import L from 'leaflet';
import HSStickyBlock from 'theme/assets/vendor/hs-sticky-block/src/js/hs-sticky-block';
import ZeroSectionGeocoderStandalone from '@/core/components/zero-section-geocoder-standalone.vue';
import HomeTagBasedEntry from '@/core/components/home-tag-based-entry.vue';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export default function (anchorIds) {
  anchorIds = anchorIds || [];

  ((id) => {
    if (!anchorIds.includes(id)) return false;
    const appContainer = document.getElementById(id);
    if (!appContainer) {
      return false;
    }

    Vue.use(VueRouter);

    const app = new Vue({
      el: appContainer,
      router: new VueRouter({
        routes: [
          { name: 'offer', path: '/' },
          { name: 'posts', path: '/posts' },
        ],
      }),
      components: {
        HomeTagBasedEntry,
        ZeroSectionGeocoderStandalone,
      },
      data: {
        geoLocation: null,
        geoJsonLow: null,
        stickyBlocks: [],
        isProgrammaticTabScrollActive: false,
        programmaticTabScrollTimeoutId: null,
      },
      watch: {
        $route(to) {
          this.activateRouteTab(this.resolveRouteName(to), true);
        },
      },
      mounted() {
        if (typeof viewConfig !== 'undefined' && viewConfig.geoLocation) {
          this.geoLocation = viewConfig.geoLocation;
        }
        if (typeof viewConfig !== 'undefined' && viewConfig.geoJsonLow) {
          this.geoJsonLow = viewConfig.geoJsonLow;
        }

        this.init();
        this.$nextTick(() => {
          this.updateStickyBlocks();
          setTimeout(() => this.updateStickyBlocks(), 120);
        });
      },
      beforeDestroy() {
        $(window).off('.publicGeoProfileSticky');
        $('html, body').stop(true, false);
        if (this.programmaticTabScrollTimeoutId) {
          window.clearTimeout(this.programmaticTabScrollTimeoutId);
          this.programmaticTabScrollTimeoutId = null;
        }
        if (this.$refs['product-info-tabs']) {
          $(this.$refs['product-info-tabs']).find('.z-tab').off('click.publicGeoProfile');
        }
        this.stickyBlocks.forEach((stickyBlock) => {
          if (stickyBlock && typeof stickyBlock.deinit === 'function') {
            stickyBlock.deinit();
          }
        });
        this.stickyBlocks = [];
      },
      methods: {
        init() {
          this.initTabs();
          this.initVendors();
        },

        initVendors() {
          if (!this.geoLocation || !this.$refs['mini-map']) {
            return;
          }

          const latlng = L.latLng(this.geoLocation.latitude, this.geoLocation.longitude);
          const map = L.map(this.$refs['mini-map'], {
            zoomControl: false,
            scrollWheelZoom: false,
            contextmenu: false,
            dragging: false,
          }).setView(latlng, 9);
          L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
          }).addTo(map);

          const geoJsonLow = this.normalizeGeoJson(this.geoJsonLow);
          if (geoJsonLow) {
            const geoJsonLayer = L.geoJSON(geoJsonLow, {
              style: {
                color: '#d9534f',
                weight: 1,
                opacity: 0.9,
                fillColor: '#d9534f',
                fillOpacity: 0.08,
              },
            }).addTo(map);
            const bounds = geoJsonLayer.getBounds();

            if (bounds && bounds.isValid()) {
              this.fitMiniMapToBounds(map, bounds);
              return;
            }
          }

          L.marker(latlng).addTo(map);
        },

        normalizeGeoJson(geoJson) {
          if (!geoJson) {
            return null;
          }

          if (typeof geoJson === 'string') {
            try {
              return JSON.parse(geoJson);
            } catch (e) {
              return null;
            }
          }

          return geoJson;
        },

        fitMiniMapToBounds(map, bounds) {
          const fitBounds = () => {
            map.invalidateSize(false);
            map.fitBounds(bounds, {
              padding: [18, 18],
              animate: false,
            });
          };

          fitBounds();
          window.setTimeout(fitBounds, 120);
        },

        initTabs() {
          if (!this.$refs['product-info-tabs']) {
            return;
          }

          const self = this;
          const $tabMenu = $(this.$refs['product-info-tabs']).find('.z-tab');

          $tabMenu
            .off('click.publicGeoProfile')
            .on('click.publicGeoProfile', function (e) {
              if (!self.isMobileViewport()) {
                return;
              }

              const $menu = $(this);
              const $clickedLink = $(e.target).closest('.nav-link');
              if ($clickedLink.length > 0) {
                const isCurrentTab = $clickedLink.hasClass('active')
                  || $clickedLink.hasClass('router-link-active')
                  || $clickedLink.hasClass('router-link-exact-active');
                const isMenuOpened = $menu.hasClass('opened');

                if (!isMenuOpened && isCurrentTab) {
                  e.preventDefault();
                  $menu.addClass('opened');
                } else {
                  $menu.removeClass('opened');
                }

                self.$nextTick(() => {
                  self.updateStickyBlocks();
                });
                return;
              }

              $menu.toggleClass('opened');
              self.$nextTick(() => {
                self.updateStickyBlocks();
              });
            });

          this.initStickyBlocks();
          this.activateRouteTab(this.resolveRouteName(this.$route), false);
        },

        resolveRouteName(route) {
          if (route && route.name) {
            return route.name;
          }

          return 'offer';
        },

        isMobileViewport() {
          return window.matchMedia('(max-width: 991.98px)').matches;
        },

        getScrollAlignmentOffset() {
          const header = document.getElementById('header');
          const fallbackOffset = this.isMobileViewport() ? 124 : 72;

          if (!header) {
            return fallbackOffset;
          }

          const rect = header.getBoundingClientRect();
          const computedStyle = window.getComputedStyle(header);
          const isFixedLike = ['fixed', 'sticky'].includes(computedStyle.position)
            || header.classList.contains('header-sticky-top')
            || header.classList.contains('js-header-fix-moment');

          if (!isFixedLike || rect.bottom <= 0) {
            return fallbackOffset;
          }

          return Math.max(0, Math.round(rect.bottom));
        },

        getTabRef(routeName) {
          const normalizedRouteName = routeName || 'offer';
          return `product-tab-${normalizedRouteName}-tab`;
        },

        closeMobileSelector() {
          if (!this.$refs['product-info-tabs']) {
            return;
          }

          const $menu = $(this.$refs['product-info-tabs']).find('.z-tab');
          $menu.removeClass('opened');

          window.requestAnimationFrame(() => {
            $menu.removeClass('opened');
          });
        },

        initStickyBlocks() {
          this.stickyBlocks.forEach((stickyBlock) => {
            if (stickyBlock && typeof stickyBlock.deinit === 'function') {
              stickyBlock.deinit();
            }
          });
          this.stickyBlocks = [];

          const $stickyBlocks = $(this.$refs['product-info-tabs']).find('.js-sticky-block');
          $stickyBlocks.each((index, el) => {
            const stickyBlock = new HSStickyBlock($(el));
            this.stickyBlocks.push(stickyBlock);
          });

          this.updateStickyBlocks();
          $(window).off('.publicGeoProfileSticky');
          $(window).on('scroll.publicGeoProfileSticky resize.publicGeoProfileSticky orientationchange.publicGeoProfileSticky', () => {
            this.updateStickyBlocks();
          });
        },

        updateStickyBlocks() {
          if (this.isProgrammaticTabScrollActive) {
            return;
          }

          this.stickyBlocks.forEach((stickyBlock) => {
            if (stickyBlock && typeof stickyBlock.update === 'function') {
              stickyBlock.update();
            }
          });
        },

        activateRouteTab(routeName, shouldScroll) {
          const resolvedRouteName = routeName || 'offer';
          const tabRef = this.getTabRef(resolvedRouteName);

          this.closeMobileSelector();
          this.setActiveTabState(resolvedRouteName);
          this.updateStickyBlocks();

          this.$nextTick(() => {
            const tabComponent = this.$refs[tabRef];
            const tabEl = tabComponent && tabComponent.$el ? tabComponent.$el : tabComponent;

            if (!tabEl) {
              this.setActiveTabState(resolvedRouteName);
              return;
            }

            const $tabEl = $(tabEl);
            const afterTabShown = () => {
              if (shouldScroll) {
                this.scrollTabNavigationIntoPlace();
                return;
              }

              this.$nextTick(() => {
                this.updateStickyBlocks();
                setTimeout(() => this.updateStickyBlocks(), 120);
              });
            };

            $tabEl.off('shown.bs.tab.publicGeoProfileScroll');
            $tabEl.one('shown.bs.tab.publicGeoProfileScroll', afterTabShown);
            $tabEl.tab('show');

            if ($tabEl.hasClass('active')
              || $tabEl.hasClass('router-link-active')
              || $tabEl.hasClass('router-link-exact-active')) {
              afterTabShown();
            }

            this.setActiveTabState(resolvedRouteName);
          });
        },

        setActiveTabState(routeName) {
          if (!this.$refs['product-info-tabs']) {
            return;
          }

          const resolvedRouteName = routeName || 'offer';
          const $tabRoot = $(this.$refs['product-info-tabs']);
          const $content = $('#ofertaTabContent');
          const tabId = `product-tab-${resolvedRouteName}`;
          const bodyId = `${tabId}-body`;

          $tabRoot.find('.nav-link')
            .removeClass('active router-link-active router-link-exact-active')
            .attr('aria-selected', 'false');
          $tabRoot.find(`#${tabId}`)
            .addClass('active router-link-active router-link-exact-active')
            .attr('aria-selected', 'true');

          $content.find('.tab-pane').removeClass('show active');
          $content.find(`#${bodyId}`).addClass('show active');
        },

        scrollTabNavigationIntoPlace() {
          const navWrapper = this.$refs['product-info-tabs'];
          if (!navWrapper) {
            return;
          }

          const targetScrollTop = Math.max(
            0,
            Math.round($(navWrapper).offset().top - this.getScrollAlignmentOffset())
          );

          this.isProgrammaticTabScrollActive = true;
          if (this.programmaticTabScrollTimeoutId) {
            window.clearTimeout(this.programmaticTabScrollTimeoutId);
            this.programmaticTabScrollTimeoutId = null;
          }

          $('html, body').stop(true, false).animate({
            scrollTop: targetScrollTop,
          }, 350, 'swing', () => {
            this.isProgrammaticTabScrollActive = false;
            this.updateStickyBlocks();
            this.programmaticTabScrollTimeoutId = window.setTimeout(() => {
              this.updateStickyBlocks();
              this.programmaticTabScrollTimeoutId = null;
            }, 120);
          });
        },
      },
    });
  })('view-public-geo-profile');
}
